import React, {useState} from 'react'
import { Button, Modal, Row, Col, Form, Alert, Card } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { GoogleMap, LoadScript, Marker, MarkerClusterer, InfoWindow, HeatmapLayer, LatLng } from '@react-google-maps/api'

function MapButton(props) {

	const [lat, setLat] = useState(props.lat)
	const [lng, setLng] = useState(props.lng)
    const [show, setShow] = useState(false)
    const {t} = useTranslation('common')
    const mapContainerStyle = {
		width: '100%',
		height: '600px'
    }

    const onClick = () => {
        console.log('onClick')
        console.log(props.lat)
        console.log(props.lng)
        setLat(props.lat)
        setLng(props.lng)
        setShow(true)
    }

	const handleConfirm = () => {
		props.onChange({lat: lat, lng: lng})
        handleClose()
    }

    const handleClose = () => {
		setShow(false)
    }

    const onLoad = map => {
        console.log('onLoad')

		map.setZoom(5)
        if (lat && lng) {
			map.setCenter({ lat: lat, lng: lng })
		} else {
			map.setCenter({ lat: 62.5, lng: 17.5 })
		}
    }

	const onMapClick = e => {
		console.log('onClick')

		setLat(e.latLng.lat())
		setLng(e.latLng.lng())
	}

    return (
        <>
	        <Button
	            onClick={onClick}
	            title={t('crudtable.edit')}
	            size="md"
	            color="info"
	            variant="outline-primary">
	            { lat && lng &&
	                <>{t('documentation.changelocation')}</>
	            }
	            { (!lat || !lng) &&
	                <>{t('documentation.chooselocation')}</>
	            }
	        </Button>
	        <Modal
				style={{overflow: 'scroll'}}
				size={'xl'}
				show={show}
				backdrop={true}
				onShow={() => console.log('onShow')}
				onHide={handleClose}
				animation={false}>
				<Modal.Header closeButton>
					<Modal.Title>
						{t('documentation.chooselocation')}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<GoogleMap
						mapContainerStyle={mapContainerStyle}
				        onLoad={onLoad}
				        options={{ minZoom: 3, zoomControl: true }}
				        onClick={onMapClick}>
				        { lat && lng &&
				            <Marker
			                    position={{lat: lat, lng: lng}}
			                />
				        }
					</GoogleMap>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={handleClose}>
						{t('crudtable.cancel')}
					</Button>
					<Button variant="primary" onClick={handleConfirm}>
						{t('crudtable.ok')}
					</Button>
				</Modal.Footer>
			</Modal>
        </>
    )
}

export default MapButton